import React, { useState, useEffect, useCallback } from "react";
import { Menu, X } from "lucide-react";
import { navItems } from "../data/mock";

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  const handleNavClick = useCallback((e, href) => {
    e.preventDefault();
    setMobileOpen(false);
    const el = document.querySelector(href);
    if (el) {
      const offset = 80;
      const top = el.getBoundingClientRect().top + window.scrollY - offset;
      window.scrollTo({ top, behavior: "smooth" });
    }
  }, []);

  return (
    <header
      className="fixed top-0 left-0 right-0 z-50 bg-[#0A0A0A] border-b border-white/[0.06]"
    >
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          {/* Logo area */}
          <div className="flex items-center gap-2.5">
            <a
              href="https://www.3dprintergear.com.au/3d-printers/formlabs/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center shrink-0"
            >
              <img
                src="/3dpg-logo.jpg"
                alt="3D Printer Gear"
                className="h-6 lg:h-7 w-auto object-contain"
              />
            </a>
            <span className="text-white/25 text-xs font-medium select-none">×</span>
            <a
              href="https://www.3dprintergear.com.au/3d-printers/formlabs/"
              target="_blank"
              rel="noopener noreferrer"
              className="flex items-center shrink-0"
            >
              <img
                src="/formlabs-logo.png"
                alt="Formlabs"
                className="h-6 lg:h-7 w-auto object-contain"
              />
            </a>
          </div>

          {/* Desktop nav */}
          <nav className="hidden lg:flex items-center gap-0.5">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => handleNavClick(e, item.href)}
                className="px-4 py-2 text-[13px] font-medium text-white/50 hover:text-white transition-colors duration-200 rounded-lg hover:bg-white/[0.04]"
              >
                {item.label}
              </a>
            ))}
          </nav>

          {/* CTA + Mobile toggle */}
          <div className="flex items-center gap-3">
            <a
              href="https://www.3dprintergear.com.au/3d-printers/shop-by-brand/formlabs/"
              target="_blank"
              rel="noopener noreferrer"
              className="hidden sm:inline-flex px-5 py-2.5 bg-[#F76B1C] hover:bg-[#E05A0F] text-white text-sm font-semibold rounded-lg transition-colors duration-200 hover:shadow-lg hover:shadow-[#F76B1C]/25"
            >
              Shop Now
            </a>
            <button
              onClick={() => setMobileOpen(!mobileOpen)}
              className="lg:hidden p-2 text-white/60 hover:text-white transition-colors"
              aria-label="Toggle menu"
            >
              {mobileOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile menu */}
      <div
        className={`lg:hidden overflow-hidden transition-all duration-300 ease-in-out ${
          mobileOpen ? "max-h-[500px] opacity-100" : "max-h-0 opacity-0"
        }`}
      >
        <div className="bg-[#0A0A0A]/98 backdrop-blur-2xl border-t border-white/[0.04]">
          <nav className="max-w-7xl mx-auto px-6 py-6 flex flex-col gap-1">
            {navItems.map((item) => (
              <a
                key={item.href}
                href={item.href}
                onClick={(e) => handleNavClick(e, item.href)}
                className="px-4 py-3 text-white/60 hover:text-white hover:bg-white/[0.04] rounded-lg transition-colors text-base"
              >
                {item.label}
              </a>
            ))}
            <a
              href="https://www.3dprintergear.com.au/3d-printers/shop-by-brand/formlabs/"
              target="_blank"
              rel="noopener noreferrer"
              className="mt-4 px-5 py-3 bg-[#F76B1C] hover:bg-[#E05A0F] text-white text-sm font-semibold rounded-lg transition-colors text-center"
            >
              Shop Now
            </a>
          </nav>
        </div>
      </div>
    </header>
  );
};
